import { resourceState, resourceMutations } from '@/store/utils/resource';
import { getFacebookCampaignAdsetsApi } from '@/api/clients/admin';
import { FACEBOOK_ADSETS } from '@/store/entities/schema_types';

export default {
  namespaced: true,
  state: resourceState(),
  mutations: resourceMutations,
  actions: {
    async getFacebookCampaignAdsets(ctx, { facebookCampaignId, queryParams = {} } = {}) {
      try {
        const response = await getFacebookCampaignAdsetsApi(facebookCampaignId, queryParams);
        const { data, meta, links } = response.data;
        const facebookCampaignAdsetIds = await ctx.dispatch('persist', data);
        ctx.commit('setIds', facebookCampaignAdsetIds);
        ctx.commit('setMeta', meta);
        ctx.commit('setLinks', links);
        return Promise.resolve({ facebookCampaignAdsetIds });
      } catch (error) {
        const { response } = error;
        return Promise.reject(response.data);
      }
    },
    persist(ctx, data) {
      return ctx.dispatch(
        'entities/persistEntities',
        {
          type: FACEBOOK_ADSETS,
          data,
        },
        { root: true }
      );
    },
  },
  getters: {
    adsets: ({ ids }, getters, { entities }) => ids.map((id) => entities.facebookAdsets.byId[id]),
  },
};
